import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export function useDeleteFund() {
  const queryClient = useQueryClient();

  const { mutateAsync, error, isLoading, reset } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.delete(`funds/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['funds'] });
    },
  });

  const deleteFund = async (id: string) => {
    return mutateAsync(id);
  };

  return {
    deleteFund,
    error,
    isLoading,
    reset,
  };
}
